import React from 'react';
import QuotaZoneList from 'components/Tvendo/Commissions/DataMaster/QuotaZone/List.js';

export default function QuotaZone() {
  return <QuotaZoneList />;
}
